import { render, staticRenderFns } from "./ItemListaDetalhes.vue?vue&type=template&id=a84f819a"
import script from "./ItemListaDetalhes.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemListaDetalhes.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports